export const initial_state = {
  layout_type: '1',
  box_type: 'main',
  items: [
    {
      id: '1',
      value: '1'
    },
    {
      id: '2',
      value: '2'
    },
    {
      id: '3',
      value: '3'
    },
  ],
  all_items: [
    {
      id: '1',
      value: '1'
    },
    {
      id: '2',
      value: '2'
    },
    {
      id: '3',
      value: '3'
    },
    {
      id: '4',
      value: '4'
    },
  ]
}

export const ACTION_TYPES = {
  SET_LAYOUT_TYPE: 'SET_LAYOUT_TYPE',
  SET_BOX_TYPE: 'SET_BOX_TYPE',
  SET_ITEMS: 'SET_ITEMS'
}

export const LAYOUT_TYPES = ['1', '2', '3', '4'];

export const BOX_TYPES = {};

LAYOUT_TYPES.forEach(t => {
  BOX_TYPES[t] = ['main', 'sub']
})

export function DragReducer(state = initial_state, action) {
  switch(action.type) {
    case ACTION_TYPES.SET_ITEMS:
      return {
        ...state,
        items: action.payload
      }
    case ACTION_TYPES.SET_LAYOUT_TYPE:
      return {
        ...state,
        layout_type: action.payload
      }
    case ACTION_TYPES.SET_BOX_TYPE:
      return {
        ...state,
        box_type: action.payload
      }
    default:
      throw new Error(`Received unsupported action: ${action && action.type}. Suported action types are: ${Object.values(ACTION_TYPES).join(' | ')}`);
  }
}